import { Component, Vue } from 'vue-property-decorator'
import { menuBtn } from '@/utils/menu_level2_button'
import { UserModule } from '@/store/modules/user'
import { gettHeaderByType } from '@/api/common'
import { getTableList, projectDissertationExportData } from '@/api/dissertation'

@Component({})
export default class DissertationProjectInfo extends Vue {
    tableHeader = []
    tableData = []
    total = 0
    page = 1
    limit = 20
    // tableKey = Math.random()
    loading = false

    dialogShow = false
    // projectTypeList = projectTypeList
    dialogConfirmButtonDisabled = false

    name = '' //论文项目名称
    userRealName = ''
    userIdList: string[] = []
    exportButtonDisabled = false
    timer = null
    // isReadonly = false

    get userList() {
        return UserModule.userList
    }

    created() {
        this.getTableHeader(); //列表表头
        this.getTableData();  //获取表格数据
    }

    buttonShow = menuBtn

    //论文列表获取表头
    async getTableHeader() {
        const data: any = await gettHeaderByType(7)
        this.tableHeader = data.headerUserList
    }
    //获取表格数据
    async getTableData() {
        this.loading = true


        const data: any = await getTableList({
            name: this.name, //论文名称
            // userRealName
            userIdList: this.userIdList, //产品负责人id
            limit: this.limit, //条数/页
            page: this.page, //页码
        })
        const {allNum, projectDissertationList} = data
        this.tableData = projectDissertationList
        this.total = allNum
        this.$nextTick(() => {
            (this.$refs.multipleTable as HTMLFormElement).doLayout();
            (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
        });
        this.loading = false
        // this.isReadonly = false
    }
    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    limitChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }
    // 点击跳转详情
    clickTableRow(row) {
        window.open(window.location.origin + this.$route.matched[0].path + '/dissertationProjectInfo?id=' + row.id + '&type=' + 1, '_blank')
    }
    // 导出论文列表
    async exportData() {
        this.exportButtonDisabled = true
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        projectDissertationExportData({
            name: this.name, //论文名称
            userIdList: this.userIdList, //产品负责人id
        }).finally(() => {
            this.exportButtonDisabled = false
        })
    }
    // 新增论文项目
    async clickShelfProjectButton(item, row) {
        if (item == '新增') {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/dissertationProjectEdit', '_blank')
            const timer = setInterval(() => {
                if (win.closed) {
                    clearInterval(timer)
                    this.getTableData()
                }
            }, 500)
        } else if (item == '编辑') {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/dissertationProjectEdit?id=' + row.id + '&type=' + 1, '_blank')
            const timer = setInterval(() => {
                if (win.closed) {
                    clearInterval(timer)
                    this.getTableData()
                }
            }, 500)
        }


        // const data: any = await getPreProjectMarketCooperation()
        // if (data.isHave) {
        //     const url = this.$router.resolve({
        //         path: 'shelfPanterProject',
        //         params: {
        //             id: '1'
        //         }
        //     }).href
        //     const win = window.open(url, '_blank')
        //     const timer = setInterval(() => {
        //         if (win.closed) {
        //             this.getTableData()
        //             delPreProjectMarketCooperation()
        //             clearInterval(timer)
        //         }
        //     }, 500)
        // } else {
        //     this.dialogShow = true
        //     this.dialogProjectPage = 1
        //     this.dialogPartnerPage = 1
        //     this.getMarketCooperation()
        // }
    }
}





